<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="商户CODE：" prop="code">
                    <el-input v-model.trim="form.code" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="list" size="mini">
            <el-table-column label="商户CODE">
                <template v-slot="scope">
                    <span>{{ scope.row.partner_code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="企业名称">
                <template v-slot="scope">
                    <span>{{ scope.row.partner_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="产品型号">
                <template v-slot="scope">
                    <span>{{ scope.row.model_code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="500">
                <template v-slot="scope">
                    <router-link :to="`/salespartner/model/detail/${scope.row.partner_code}/${scope.row.model_code}`">
                        <el-button type="primary" size="mini" class="btnClass">详情</el-button>
                    </router-link>
                    <el-button type="primary" style="margin-left: 8px;" size="mini"
                        @click="setDeviceCommission(scope.row)">设置设备激活补贴</el-button>
                    <el-button type="primary" style="margin-left: 8px;" size="mini"
                        @click="setOrderCommission(scope.row)">设置订单佣金</el-button>
                    <el-button type="primary" style="margin-left: 8px;" size="mini"
                        @click="setDeviceFactorySubsidy(scope.row)">设置设备生产补贴</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
        <el-dialog title="设置设备激活补贴" v-model="deviceCommissionFormVisible" width="600px" size="small">
            <el-form :model="deviceCommissionForm" :rules="deviceCommissionFormRules" ref="deviceCommissionFormRef"
                size="small" label-width="auto">
                <el-form-item label="区域：" prop="region">
                    <el-select v-model="deviceCommissionForm.region" style="width: 240px" placeholder="请选择区域">
                        <el-option label="亚洲" value="AS"></el-option>
                        <el-option label="欧洲" value="EU"></el-option>
                        <el-option label="非洲" value="AF"></el-option>
                        <el-option label="大洋洲" value="OC"></el-option>
                        <el-option label="北美洲" value="NA"></el-option>
                        <el-option label="南极洲" value="AN"></el-option>
                        <el-option label="南美洲" value="SA"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="补贴：" prop="commission_rate">
                    <el-input-number v-model="deviceCommissionForm.commission_rate" :min="0" :max="999" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button size="small" @click="deviceCommissionFormVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="
                        setDeviceCommissionSubmit(deviceCommissionFormRef)
                        ">设置</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog title="设置订单佣金" v-model="orderCommissionFormVisible" width="600px" size="small">
            <el-form :model="orderCommissionForm" :rules="orderCommissionFormRules" ref="orderCommissionFormRef"
                size="small" label-width="auto">
                <el-form-item label="区域：" prop="region">
                    <el-select v-model="orderCommissionForm.region" style="width: 240px" placeholder="请选择区域">
                        <el-option label="美洲" value="us"></el-option>
                        <el-option label="欧洲" value="eu"></el-option>
                        <el-option label="中国" value="cn"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="佣金比例：" prop="commission_rate">
                    <el-input-number v-model="orderCommissionForm.commission_rate" :min="0" :max="1" :precision="2"
                        :step="0.1" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button size="small" @click="orderCommissionFormVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="
                        setOrderCommissionSubmit(orderCommissionFormRef)
                        ">设置</el-button>
                </span>
            </template>
        </el-dialog>
        <el-dialog title="设置设备生产补贴" v-model="deviceFactorySubsidyFormVisible" width="600px" size="small">
            <el-form :model="deviceFactorySubsidyForm" :rules="deviceFactorySubsidyFormRules"
                ref="deviceFactorySubsidyFormRef" size="small" label-width="auto">
                <el-form-item label="每台设备补贴：" prop="amount_cny">
                    <el-input-number v-model="deviceFactorySubsidyForm.amount_cny" :min="0" :max="999" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button size="small" @click="deviceFactorySubsidyFormVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="
                        setDeviceFactorySubsidySubmit(deviceFactorySubsidyFormRef)
                        ">设置</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import util from '../../../util/util'
import api from '../../../axios/api'

export default {
    setup() {
        const router = useRouter()
        const form = reactive({
            code: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const list = ref([])
        const deviceCommissionForm = reactive({
            partner_code: '',
            model_code: '',
            region: '',
            commission_rate: ''
        })
        const deviceCommissionFormRef = ref()
        const deviceCommissionFormRules = reactive({
            region: [
                { required: true, message: '请选择区域', trigger: 'change' }
            ],
            commission_rate: [
                { required: true, message: '请输入补贴', trigger: 'blur' }
            ]
        })
        const deviceCommissionFormVisible = ref(false)
        const orderCommissionForm = reactive({
            partner_code: '',
            model_code: '',
            region: '',
            commission_rate: ''
        })
        const orderCommissionFormRef = ref()
        const orderCommissionFormRules = reactive({
            region: [
                { required: true, message: '请选择区域', trigger: 'change' }
            ],
            commission_rate: [
                { required: true, message: '请输入佣金比例', trigger: 'blur' }
            ]
        })
        const orderCommissionFormVisible = ref(false)
        const deviceFactorySubsidyForm = reactive({
            partner_code: '',
            model_code: '',
            amount_cny: ''
        })
        const deviceFactorySubsidyFormRef = ref()
        const deviceFactorySubsidyFormRules = reactive({
            amount_cny: [
                { required: true, message: '请输入每台设备补贴金额', trigger: 'blur' }
            ]
        })
        const deviceFactorySubsidyFormVisible = ref(false)

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.SalesPartnerModelList({
                ...toRaw(form),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { data, page_info } = res.data.data
                list.value = data
                pagination.total = page_info.total
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const add = () => {
            router.push('/salespartner/list/add/0')
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        const changeStatus = async (row, status) => {
            const res = await api.SalesPartnerUpdateStatus({
                code: row.code,
                status
            })
            if (res.data.code === 200) {
                ElMessage.success('状态更新成功')
                onSearch()
            } else {
                ElMessage.error('状态更新失败: ' + res.data.msg)
            }
        }

        const setDeviceCommission = (row) => {
            deviceCommissionFormVisible.value = true
            deviceCommissionForm.partner_code = row.partner_code
            deviceCommissionForm.model_code = row.model_code
            deviceCommissionForm.region = ''
            deviceCommissionForm.commission_rate = ''
        }

        const setDeviceCommissionSubmit = (formEl) => {
            if (!formEl) return
            formEl.validate(async (valid, fields) => {
                if (valid) {
                    const res = await api.SalesPartnerModelDeviceCommissionSet(
                        toRaw(deviceCommissionForm)
                    )
                    if (res.data.code === 200) {
                        ElMessage.success('设置成功')
                        deviceCommissionFormVisible.value = false
                        onSearch()
                    } else {
                        ElMessage.error('设置失败: ' + res.data.msg)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const setOrderCommission = (row) => {
            orderCommissionFormVisible.value = true
            orderCommissionForm.partner_code = row.partner_code
            orderCommissionForm.model_code = row.model_code
            orderCommissionForm.region = ''
            orderCommissionForm.commission_rate = ''
        }

        const setOrderCommissionSubmit = (formEl) => {
            if (!formEl) return
            formEl.validate(async (valid, fields) => {
                if (valid) {
                    const res = await api.SalesPartnerModelOrderCommissionSet(
                        toRaw(orderCommissionForm)
                    )
                    if (res.data.code === 200) {
                        ElMessage.success('设置成功')
                        orderCommissionFormVisible.value = false
                        onSearch()
                    } else {
                        ElMessage.error('设置失败: ' + res.data.msg)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const setDeviceFactorySubsidy = (row) => {
            deviceFactorySubsidyFormVisible.value = true
            deviceFactorySubsidyForm.partner_code = row.partner_code
            deviceFactorySubsidyForm.model_code = row.model_code
            deviceFactorySubsidyForm.amount_cny = ''
        }

        const setDeviceFactorySubsidySubmit = (formEl) => {
            if (!formEl) return
            formEl.validate(async (valid, fields) => {
                if (valid) {
                    const res = await api.SalesPartnerModelDeviceFactorySubsidySet(
                        toRaw(deviceFactorySubsidyForm)
                    )
                    if (res.data.code === 200) {
                        ElMessage.success('设置成功')
                        deviceFactorySubsidyFormVisible.value = false
                        onSearch()
                    } else {
                        ElMessage.error('设置失败: ' + res.data.msg)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        onMounted(() => {
            onSearch()
        })

        return {
            form,
            onSearch,
            list,
            formRef,
            pagination,
            handleCurrentChange,
            add,
            resetForm,
            util,
            changeStatus,
            setDeviceCommission,
            setDeviceCommissionSubmit,
            deviceCommissionForm,
            deviceCommissionFormRef,
            deviceCommissionFormRules,
            deviceCommissionFormVisible,
            orderCommissionForm,
            orderCommissionFormRef,
            orderCommissionFormRules,
            orderCommissionFormVisible,
            setOrderCommission,
            setOrderCommissionSubmit,
            deviceFactorySubsidyForm,
            deviceFactorySubsidyFormRef,
            deviceFactorySubsidyFormRules,
            deviceFactorySubsidyFormVisible,
            setDeviceFactorySubsidy,
            setDeviceFactorySubsidySubmit
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
